import * as Colors from 'material-ui/styles/colors';

export default {
  dialogBody: {
    padding: 0,
    fontSize: 16,
    color: Colors.grey600
  },
  dialogContent: {
    width: 500
  },
  dialogHeader: {
    fontSize: 24,
    backgroundColor: Colors.red900,
    color: 'white',
    height: 60,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  dialogFooter: {
    width: '100%',
    height: '70px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  infoBoxIcon: {
    fontSize: 30,
    marginLeft: 15,
    marginRight: 25
  },
  reportErrorButton: {
    margin: 20
  },
  reportErrorButtonLabel: {
    color: 'black'
  },
  retryButton: {
    margin: 20,
    color: Colors.green500
  },
  errorMessageContainer: {
    margin: 20
  },
  closeIcon: {
    color: 'white'
  }
};
